export default (content) => {
  let trimmedContent = {
    ...content,
    Blocks: []
  }

  let firstEmptyFound = false
  let emptyBlocksToBeAdded = []

  content.Blocks.forEach(Block => {
    if (!firstEmptyFound) {
      if (Block.Type || Block.Text.length > 0) {
        firstEmptyFound = true
        trimmedContent.Blocks.push(Block)
      }
    } else {
      if (Block.Type || Block.Text.length > 0) {
        trimmedContent.Blocks.push(...emptyBlocksToBeAdded, Block)
        emptyBlocksToBeAdded = [] // reset pending blocks
      } else {
        emptyBlocksToBeAdded.push(Block)
      }
    }
  })

  return trimmedContent
}
